// Components
import { BaseImage } from 'components'

// Interface
import { ILayoutAuthProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'

// React Router Dom
import { useHistory } from 'react-router-dom'

// Styles
import './styles.scss'

const LayoutAuth = ({ children, meta }: ILayoutAuthProps) => {
  // Hook
  const { t } = useTranslation()
  const history = useHistory()

  /**
   * @description Redirect to home
   *
   * @return {void} void
   */
  const onRedirectToHome = () => {
    history.push('/')
  }

  /**
   * @description Redirect to contact us
   *
   * @return {void} void
   */
  const onRedirectToContactUs = (): void => {
    history.push('/contact-us')
  }

  return (
    <div className="layout-auth-wrapper">
      <div className="layout-auth-container">
        <div className="layout-auth-header cursor-pointer">
          <BaseImage isImage isSvg image="lsp-logo" onClick={onRedirectToHome} />
        </div>
        <div className={`layout-auth-body ${meta.attrs?.centeredLayout ? 'centered' : ''} `}>
          {meta.attrs?.centeredLayout ? (
            <>
              <BaseImage isImage image={meta.attrs?.image} height="350px" />
              <p className="font-24 font-weight-700 pt-8">{t(meta.attrs?.label || '')}</p>
              <p className="font-16 font-weight-400">{t(meta.attrs?.subLabel || '')}</p>
              {/* @note Always render the empty HTML in children :) */}
              {children}
            </>
          ) : (
            <div className="flex flex-row">
              <div className="hidden md:flex flex-col items-center h-auto justify-center layout-auth-body-left-side">
                <BaseImage isImage image={meta.attrs?.image} height="320px" />
                <p className="font-24 font-weight-700">{t('auth.login.label')}</p>
                <p className="font-16 font-weight-400">{t('auth.login.subLabel')}</p>
              </div>
              <div className="flex flex-col items-center justify-center m-0 md:ml-12 layout-auth-body-right-side">
                <div style={{ zIndex: 1 }} className="layout-auth-body-right-side-image">
                  {/* <BaseImage isImage image={meta.attrs?.image} height="auto" width="auto" /> */}
                </div>

                <div style={{ zIndex: 2 }}>{children}</div>
              </div>
            </div>
          )}
        </div>
        <footer className="layout-auth-footer flex flex-col md:flex-row items-center justify-center">
          <p className="font-14">Copyright ©2021 Astra International</p>
          <p className="font-14 ml-1">
            | <a 
              href="https://www.astra.co.id/privacy-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:font-weight-700 hover:text-blue-800 underline"
            >
              Kebijakan Privasi
            </a>
          </p>
          <p className="font-14 font-weight-700 ml-1 cursor-pointer" onClick={onRedirectToContactUs}>
            | {t('app.contactUs')}
          </p>
        </footer>
      </div>
    </div>
  )
}

export { LayoutAuth }
